<script setup lang="ts">
import { Motion } from 'motion-v'
const props = withDefaults(
  defineProps<{
    class?: string
    withGradient?: boolean
    title: string
    subTitle?: string
    description?: string
  }>(),
  {
    class: '',
    withGradient: true,
    subTitle: undefined,
    description: undefined
  }
)

const slots = useSlots()
</script>
<template>
  <div
    :class="
      cn(
        'h-full w-full py-5 lg:py-12 2xl:py-32 bg-background',
        {
          relative: props.withGradient
        },
        props.class
      )
    "
  >
    <UiBgGrid v-if="props.withGradient" class="absolute inset-0" />
    <UiContainer>
      <slot name="title">
        <Motion
          :initial="{ opacity: 0, translateY: 40 }"
          :while-in-view="{ opacity: 1, translateY: 0 }"
          :in-view-options="{ once: true }"
        >
          <UiSectionTitle
            class="lg:max-w-11/12 text-center lg:mx-auto"
            :title="props.title"
            title-as="h2"
            :sub-title="props.subTitle"
            sub-title-as="h1"
            variant-size="large"
            :description="props.description"
            view-transition
          />
        </Motion>
      </slot>
      <slot />
    </UiContainer>
    <div v-if="slots.decorator" class="relative">
      <slot name="decorator" />
    </div>
  </div>
</template>
